.<div class="container">
  <div class="row">
    <div class="col">
      <div class="mb-4">
        <h2>How knowing sooner helps you prepare</h2>
        <p class="mb-5">Don’t just take it from us, hear from real people who have benefited from screening for type 1
          diabetes. Whatever your risk factors, screening helps you gain the knowledge and time you may need to prepare
          for type 1 diabetes before insulin dependence beings.</p>
      </div>
      <div video-carousel [videoCarouselData]="videoData" [transcript]="true"></div>
    </div>
  </div>
</div>